import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot, UrlSegment, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanLoad, CanActivate {

  constructor(
    public authService: AuthService,
    private router: Router
  ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean | UrlTree |
        Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        // Chequeo síncrono: no dispara /auth/verificar en cada navegación.
        // La revalidación real corre una sola vez al arranque (AppComponent).
        if (!this.authService.hasToken()) {
            this.router.navigate(['/profile-authentication']);
            return false;
        }
        return true;
    }

    canLoad(
        route: Route, segments: UrlSegment[]): boolean |
        UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        return this.authService.hasToken();
    }
    
}
